import { createSelector } from '@ngrx/store';

import {
  selectVistaUsuario,
  VistaUsuarioState
} from '../../vista-usuario/vista-usuario.state';

import {
  EntityLocalidadesState,
  entityLocalidadesAdapter
} from './entity-localidades.state';

const { selectEntities, selectAll } = entityLocalidadesAdapter.getSelectors();

export const getError = (state: EntityLocalidadesState): any => state.error;

export const getIsLoading = (state: EntityLocalidadesState): boolean =>
  state.isLoading;

export const selectLocalidadesState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.localidades
);

export const selectAllLocalidades = createSelector(
  selectLocalidadesState,
  selectAll
);
export const selectEntitiesLocalidades = createSelector(
  selectLocalidadesState,
  selectEntities
);

// MemoizedSelector<object,any>
export const selectLocalidadesError = createSelector(
  selectLocalidadesState,
  getError
);

// MemoizedSelector<object,any>
export const selectLocalidadesIsLoading = createSelector(
  selectLocalidadesState,
  getIsLoading
);
